import BackButton from '../BackButton/BackButton'
import Divider from '../Divider/Divider'
import Header from '../Header/Header'
import classes from './Breadcrumb.module.scss'
import type {
  ReactElement,
  ReactNode
} from 'react'

export interface Props {
  link?: ReactElement<{ href: string }>
  title?: string
  children?: ReactNode
  label?: string
}

interface OverflowedTitleProps {
  title: string
}

const OverflowedTitle = ({ title }: OverflowedTitleProps) =>
  <span className={classes.Breadcrumb}>
    <span className={classes.Title}>
      {title}
    </span>
    <span className={classes.Divider}>
      <Divider isVertical />
    </span>
  </span>

const Breadcrumb = ({
  link,
  title,
  children,
  label
}: Props) =>
  <span
    aria-label={label}
    className={classes.Breadcrumb}
  >
    {
      link &&
        <BackButton>
          {link}
        </BackButton>
    }
    {
      (children || title) &&
        <>
          <div className={classes.Divider}>
            <Divider isVertical />
          </div>
          <Header
            hasNoTopMargin
            rank={2}
          >
            {
              title
                ? <OverflowedTitle title={title} />
                : children
            }
          </Header>
        </>

    }
  </span>

export default Breadcrumb
